import React, { FunctionComponent, useCallback, useState, useEffect } from "react";
import styles from "./PaymentDetails.module.css";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { subscriptionDetailsData } from "../../Components/mockData";
import { useHistory } from "react-router";
import useRazorpay from "react-razorpay";
import axios from "axios";
import { useLocation } from "react-router";
import { url } from "../../Values/constants";
import { firestore, functions } from "../../Firebase";
import SuccessAndFailureModal from "../../Components/SuccessAndFailureModal/SuccessAndFailureModal";
import { addMonths, getDateString, sendMail, addMonthsWithoutTimestamp, getFormattedDate, addMonthsTP, addMonthsWithoutTimestampTP } from "../../Components/../Values/utils";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { numberWithCommas } from "../../Services/booking";
import { fetchCouponList } from "../../Services/contacts";
import "../../theme-vars.css";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";
import { useMediaQuery } from "@mui/material";
import InputTextValue from "../../Components/TextInput/InputTextValue";

type props = {
  history: any;
  user: any;
  contacts: {
    data: any;
  };
  organizationUsers: any;
  role: any;
  teamLeadUsers: any;
  filterObject: any;
  filterSort: any;
  refreshContacts: boolean;
  searchString: string;
  theme: any;
  organizationData: any;
  authToken: any;
};

// const PaymentDetails = ({ theme }: any) => {
const PaymentDetails: FunctionComponent<props> = ({
  user,
  contacts,
  organizationUsers,
  role,
  teamLeadUsers,
  filterObject,
  filterSort,
  refreshContacts,
  searchString,
  theme,
  organizationData,
  authToken
}) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const dispatcher = useDispatch();
  const Razorpay = useRazorpay();
  const location: any = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [isTransactionSuccess, setIsTransactionSuccess] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [coupons, setCoupons] = useState<any>([]);
  const [filterData, setFilterData] = useState<any[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [amountTotal, setAmountTotal] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponError, setCouponError] = useState("");

  const options = [
    { value: 1, label: '1 Month' },
    { value: 3, label: '3 Months' },
    { value: 6, label: '6 Months' },
    { value: 12, label: '12 Months' },
  ];
  const [selectedOption, setSelectedOption] = useState<any>({ value: 1, label: '1 Month' });
  const animatedComponents = makeAnimated();
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.9); // Set an initial value, adjust as needed

  const handleResize = () => {
    // Update maxHeight when the window is resized
    setMaxHeight(window.innerHeight * 0.9); // Adjust the multiplier as needed
  };

  useEffect(() => {
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const unsub = fetchCouponList("QzA8Wu90bmJkLc6eYMHd", (data) =>
      setFilterData(data)
    );
    return () => {
      unsub();
    };
  }, []);

  let totalLicenses = organizationData && organizationData.no_of_employees;
  let costPerLicense = organizationData && organizationData.cost_per_license;
  let validFrom = organizationData && organizationData.valid_from;
  let validTill = organizationData && organizationData.valid_till;
  let orgName = organizationData && organizationData.organization_name;
  let mailId = organizationData && organizationData.org_mail_id && organizationData.org_mail_id[0];
  let address = organizationData && organizationData.address;
  let contactNumber = organizationData && organizationData.mobile_number;
  let gstNumber = organizationData && organizationData.GSTIN;
  let organization = organizationData && organizationData.organization_name;
  let monthlyAmount = Math.round(totalLicenses * costPerLicense);
  let amount: any = Math.round((totalLicenses * costPerLicense * selectedOption.value));
  let tax: any = Math.round((18 / 100) * amount);
  let totalAmount = Number(amount) + Number(tax);

  let adminMailId = organizationData && organizationData.admin_email_id;
  let isIGST = organizationData && organizationData.is_IGST;

  const updatePlan = (organizationId: any) => {
    let totalMonths = localStorage.getItem('totalMonths') ? Number(localStorage.getItem('totalMonths')) : selectedOption.value;
    let docRef = firestore.collection("organizations").doc(organizationId);
    docRef.update({
      payment_status: true,
      trial_period: false,
      valid_from: validFrom,
      valid_till: organizationData.trial_period === true ? addMonthsTP(totalMonths) : addMonths(validTill, totalMonths)
    })
      .then(() => {
        setOpenModal(true);
        setIsTransactionSuccess(true);
      })
      .catch((error) => {
        console.log("error", error);
        setOpenModal(true);
        setIsTransactionSuccess(false);
      });
  }


  const handleApplyCoupon = () => {
    setCouponMessage("");
    setCouponError("");
    setAmountTotal(0);
    setDiscountAmount(0);
    setIsCouponApplied(false);

    // 1. Validate selected coupon
    const coupon = filterData.find((c) => String(c.name) === String(selectedCoupon));

    if (!coupon) {
      setCouponError("❌ Invalid coupon code.");
      setIsCouponApplied(false);
      return;
    }
    // 2. Apply discount if valid
    const discount = (totalAmount * Number(coupon.value)) / 100; // Convert selectedCoupon to a number
    const discountedTotal = totalAmount - discount;
    setAmountTotal(discountedTotal);
    setDiscountAmount(discount);
    setIsCouponApplied(true);

    // 3. Success message
    setCouponMessage(`🎉 Congratulations! Coupon "${coupon.name}" applied successfully.`);
  };

  const handleClearCoupon = () => {
    setAmountTotal(0);
    setDiscountAmount(0);
    setIsCouponApplied(false);
    setCouponMessage("");
    setCouponError("");
    setSelectedCoupon("");
  }

  const handlePayment = useCallback(async (totalAmount: any) => {
    const mailPaymentSuccessUser = `<div>Hello,</div> <br/><div>Your payment for INR ${totalAmount} was successful and we have renewed your subscription.</div> <br/>  <div>Thanks for using Readpro.</div>  <br/>`;
    const mailPaymentSuccess = `<div>Hello,</div> <br/><div>${orgName} has renewed their subscription.</div> <br/>`;
    const mailPaymentFailureUser = `<div>Hello,</div> <br/><div>Your payment for INR ${totalAmount} has failed and we were not able to renewe your subscription, Please try again.</div> <br/>  <div>Thanks for using Readpro.</div>  <br/>`;
    const mailPaymentFailure = `<div>Hello,</div> <br/><div>${orgName} was trying to renew their subscription but the payment was not successful.</div> <br/> <div>Please reach out to them as soon as possible.</div>  <br/>`;
    axios.defaults.headers.common['x-access-token'] =

      authToken
    const res = await axios.post(url + '/payments/createorder', {
      "amount": totalAmount
    });
    let totalMonths = localStorage.getItem('totalMonths') ? Number(localStorage.getItem('totalMonths')) : selectedOption.value;
    let paymentFrom = new Date().toISOString();

    let paymentTill = organizationData.trial_period === true ? addMonthsWithoutTimestampTP(totalMonths) : addMonthsWithoutTimestamp(validTill, totalMonths);
    let formattedPaymentFrom = getFormattedDate(paymentFrom);
    let formattedPaymentTill = getFormattedDate(paymentTill);
    const { data } = res;
    const options: any = {
      // key: "rzp_test_N91p6PGNyIPGjR",
      key: "rzp_live_n7jBvjTYwWS5px",
      amount: totalAmount,
      currency: "INR",
      name: "Lead Rubix",
      // description: "Test Transaction",
      description: "Transaction",
      // image: "https://www.itsforyou.live/public/uploads/imp/1624874830.png",
      order_id: data.order.id,
      handler: async (res: any) => {
        axios.defaults.headers.common['x-access-token'] =
          authToken
        const resa = await axios.post(url + '/payments/paymentverification',
          {
            uid: user.auth_id,
            contact_no: user.admin_contact_number,
            contact_owner_email: user.user_email,
            organization_id: user.organization_id,
            receipt: data.order.receipt,
            currency: "INR",
            amount: data.order.amount / 100,
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
            invoice_no: "201906-28",
            company: orgName,
            email: adminMailId,
            phone: contactNumber,
            address: address,
            transaction_date: paymentFrom,
            due_date: paymentTill,
            paymentFrom: paymentFrom,
            paymentTill: paymentTill,
            units: 1,
            igst: isIGST,
            items: [
              {
                serialNumber: 1,
                description: `${totalLicenses} Licenses @ ${costPerLicense}/- each. (From ${formattedPaymentFrom} to ${formattedPaymentTill})`,
                qty: 1,
                hsn: 997331,
                rate: totalAmount,
                taxAmount: Number(tax),
              },
            ]
          }
        );
        if (resa.data.success) {
          updatePlan(user.organization_id);
          // sendMail(mailPaymentSuccessUser,mailId,"Payment Successful");
          // sendMail(mailPaymentSuccess,["hr@notegtechnologies.com","anujchauhan@notegtechnologies.com"],"Payment Successful");
        } else {
          setOpenModal(true);
          setIsTransactionSuccess(false);
          // sendMail(mailPaymentFailureUser,mailId,"Payment Failed");
          // sendMail(mailPaymentFailure,["hr@notegtechnologies.com","anujchauhan@notegtechnologies.com"],"Payment Failed");
        }
      },
      prefill: {
        name: orgName,
        email: mailId,
        contact: contactNumber,
      },
      notes: {
        address: address,
      },
      // theme: {
      //   color: "#3399cc",
      // },
    };
    const rzpay = new Razorpay(options);
    rzpay.on("payment.failed", (err: any) => {
      setOpenModal(true);
      setIsTransactionSuccess(false);
      sendMail(mailPaymentFailureUser, mailId, "Payment Failed");
      sendMail(mailPaymentFailure, ["hr@notegtechnologies.com", "anujchauhan@notegtechnologies.com"], "Payment Failed");
    });

    rzpay.open();
  }, [Razorpay]);
  const history = useHistory();
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const tdStyles = {
    backgroundColor: theme
      ? themeColors.tdBackgroundColor
      : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const trBorderStyles = {
    borderBottomColor: theme
      ? `1px solid ${themeColors.trBorderColor}`
      : `1px solid ${themeColors.trBorderColorDark}`,
  };
  const thStyles = {
    backgroundColor: theme
      ? themeColors.thBackgroundColor
      : themeColors.thBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const selectInputContainerStyles = { width: "140px", marginRight: "5px" };

  useEffect(() => {
    localStorage.setItem("totalMonths", selectedOption.value);
  }, [selectedOption])

  return (
    <div
      className={styles.parent}
      style={{
        ...containerStyles,
        marginTop: isMobile ? "6%" : "3.5%",
        padding: isMobile ? "12px" : "0",
        minHeight: isMobile ? "100vh" : undefined,
      }}
    >
      {openModal &&
        (
          <SuccessAndFailureModal
            isSuccess={isTransactionSuccess}
            open={openModal}
            close={() => setOpenModal(false)}
          />)
      }
      <div
        className={styles.container}
        style={{
          maxHeight: isMobile ? "100vh" : `${maxHeight}px`,
          overflowX: "hidden",
          overflowY: "auto",
          marginBottom: isMobile ? "20px" : "20px",
          width: isMobile ? "100%" : undefined,
          padding: isMobile ? "0" : undefined,
        }}
      >
        <div>
          <h5
            style={{
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-medium)",
              textAlign: "center",
              marginBottom: isMobile ? "20px" : undefined
            }}
            className="fw-bold"
          >
            Manage your Leads Rubix Subscription
          </h5>
          <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }} className="mt-2">Payment Details</h6>
          <div className={styles.unifiedBox}>
            <div
              className={
                !isMobile ? styles.flexRowContainer : ""
              }
              style={{
                width: "100%",
                flexDirection: isMobile ? "column" : "row",
                display: "flex",
                gap: isMobile ? "12px" : "0",
              }}
            >
              <div
                className={styles.unifiedSection}
                style={{
                  flex: 1,
                  minHeight: !isMobile ? "220px" : undefined,
                  boxSizing: "border-box",
                  borderRight: !isMobile ? "1px solid #eee" : "none",
                  width: isMobile ? "100%" : undefined,
                  padding: isMobile ? "8px" : undefined,
                }}
              >
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }} className="text-center">Billing Details</h6>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }} className="mt-2">
                  Organization: {organization}
                </h6>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Address: {address}</h6>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Phone : {contactNumber}</h6>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>GSTIN : {gstNumber}</h6>
              </div>
              <div
                className={styles.unifiedSection}
                style={{
                  flex: 1,
                  minHeight: !isMobile ? "220px" : undefined,
                  boxSizing: "border-box",
                  width: isMobile ? "100%" : undefined,
                  padding: isMobile ? "8px" : undefined,
                }}
              >
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <table
                    className="table rounded bg-white"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      fontSize: isMobile ? "13px" : undefined,
                    }}
                  >
                    <thead className="bg-light" style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>
                      <tr>
                        <th style={thStyles}>Item</th>
                        <th style={thStyles}>Duration</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>
                      <tr className="border-bottom">
                        <td style={tdStyles}>
                          <p className="fw-bold mb-1">Leads Rubix License</p>
                          <p>₹ {numberWithCommas(monthlyAmount)} / month <br /> (At ₹{numberWithCommas(costPerLicense)} for {totalLicenses} Licenses)</p>
                        </td>
                        <td style={tdStyles}>
                          <div style={{ ...selectInputContainerStyles }}>
                            <Select
                              className={styles.select}
                              defaultValue={selectedOption}
                              onChange={setSelectedOption}
                              options={options}
                              menuPlacement="auto"
                              value={selectedOption}
                              components={animatedComponents}
                              showCheckbox={true}
                              isSearchable={true}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999 // ensure dropdown is above overlays
                                }),
                                menu: (base) => ({
                                  ...base,
                                  width: isMobile ? '32vw' : '120px', // wider for all options
                                  maxWidth: isMobile ? '32vw' : '120px',
                                  maxHeight: '400px', // show all options with scroll
                                  left: isMobile ? '2.5vw' : base.left,
                                  right: isMobile ? '2.5vw' : base.right,
                                  boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                                  borderRadius: '8px',
                                  padding: '0',
                                }),
                                control: (base) => ({
                                  ...base,
                                  width: '100%',
                                  minWidth: 0,
                                  fontSize: isMobile ? "13px" : "var(--font-size-small)",
                                  borderRadius: '8px',
                                  borderColor: '#d1d5db',
                                  boxShadow: 'none',
                                  background: '#fff',
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  fontSize: isMobile ? "13px" : "var(--font-size-small)",
                                  backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
                                  color: "#222",
                                  cursor: "pointer",
                                  padding: '10px 16px',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: "#222",
                                  fontWeight: 500,
                                }),
                                indicatorSeparator: () => ({
                                  display: 'none'
                                }),
                                dropdownIndicator: (base) => ({
                                  ...base,
                                  color: "#222"
                                }),
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {filterData.length > 0 && (<>
            <h5
              style={{
                fontFamily: "var(--font-family-main)",
                fontSize: isMobile ? "var(--font-size-large)" : "var(--font-size-medium)",
                marginTop: isMobile ? "12px" : undefined,
              }}
              className="fw"
            >
              Apply Discount Coupon
            </h5>
            <div
              className="bg-light justify-content-end mt-2"
              style={{
                width: "100%",
                padding: isMobile ? "8px" : "10px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: isMobile ? "flex-start" : "space-between",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "8px" : "0",
                fontFamily: "var(--font-family-main)",
                fontSize: isMobile ? "13px" : "var(--font-size-small)",
              }}
            >
              <div style={{ width: isMobile ? "100%" : "75%" }}>
                <InputTextValue
                  title={"Coupon"}
                  value={selectedCoupon}
                  onChange={(e) => setSelectedCoupon(e.target.value)}
                />
              </div>
              <StyledSubmitButton
                onClick={handleApplyCoupon}
              >
                Apply
              </StyledSubmitButton>
              {discountAmount > 0 && (
                <span
                  style={{
                    marginLeft: isMobile ? "0" : "5px",
                    color: "red",
                    fontSize: isMobile ? "18px" : "22px",
                    cursor: "pointer",
                  }}
                  onClick={handleClearCoupon}
                >
                  ✖
                </span>
              )}
            </div>
            {couponMessage && (
              <p style={{ color: "green", marginTop: "8px", fontSize: "14px" }}>
                {couponMessage}
              </p>
            )}

            {couponError && (
              <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
                {couponError}
              </p>
            )}
          </>)}
          {discountAmount > 0 && (
            <p className="text-success mt-2" style={{
              marginLeft: "10px", fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)"
            }}>
              Coupon applied! Discount: ₹ {discountAmount}
            </p>
          )}
          {/* Centered Amount to be paid now */}
          <div style={{ textAlign: "center", marginTop: "32px" }}>
            <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Amount to be paid now</h6>
            <h1 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {isCouponApplied ? amountTotal : numberWithCommas(totalAmount)}</h1>
            {discountAmount > 0 ? (
              <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {numberWithCommas(amount)} + {numberWithCommas(tax)}(18% Tax) - ₹ {discountAmount} Discount</h6>
            ) : (
              <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {numberWithCommas(amount)} + {numberWithCommas(tax)}(18% Tax)</h6>
            )}
          </div>
          {!isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "row" : "row",
                justifyContent: "center",
                marginTop: 20,
                width: "100%",
                gap: isMobile ? "8px" : "0",
              }}
            >
              <div style={{ marginRight: isMobile ? 0 : 8 }}>
                <StyledCancelButton
                  onClick={() => {
                    history.push("/subscriptionDetails");
                  }}
                >
                  Cancel
                </StyledCancelButton>
              </div>
              <div style={{ marginRight: isMobile ? 0 : 8 }}>
                <StyledSubmitButton
                  onClick={() => {
                    handlePayment(totalAmount);
                  }}
                >
                  Proceed
                </StyledSubmitButton>
              </div>
            </div>
          )}
          {isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                gap: isMobile ? "8px" : "0",
                position: isMobile ? "fixed" : "static",
                left: 0,
                bottom: isMobile ? 0 : undefined,
                background: isMobile ? "#fff" : undefined,
                padding: isMobile ? "12px 0" : undefined,
                boxShadow: isMobile ? "0 -2px 8px rgba(0,0,0,0.05)" : undefined,
                zIndex: isMobile ? 100 : undefined,
              }}
            >
              <div style={{ marginRight: isMobile ? 0 : 8 }}>
                <StyledCancelButton
                  onClick={() => {
                    history.push("/subscriptionDetails");
                  }}
                >
                  Cancel
                </StyledCancelButton>
              </div>
              <div style={{ marginRight: isMobile ? 0 : 8 }}>
                <StyledSubmitButton
                  onClick={() => {
                    handlePayment(totalAmount);
                  }}
                >
                  Proceed
                </StyledSubmitButton>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <div
          className="card px-4 pt-2 w-100 d-flex flex-row justify-content-between position-absolute bottom-0 end-0"
          style={cardContainerStyles}
        >
          <div>
            <h6>accounts@itsforyou.live</h6>
            <p>(For payments and billing questions)</p>
          </div>
          <div>
            <h6>8755964699</h6>
            <p>(Toll Free 24 hours - Monday to Friday)</p>
          </div>
        </div> */}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    filterObject: state.filter,
    filterSort: state.filterSort,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(PaymentDetails);
